import React, { createContext, useContext, useState, useCallback } from 'react';

const DEFAULT_FILTERS = {
  category: null, category_l2: null, category_l3: null,
  supplier: null, region: null, country: null,
  sbu: null, fiscal_year: null,
  startDate: null, endDate: null,
  minAmount: null, maxAmount: null,
  buyer: null, department: null,
  cost_center: null, business_unit: null, addressability: null,
};

const FilterContext = createContext(null);

export function FilterProvider({ children }) {
  const [filters, setFiltersRaw] = useState(DEFAULT_FILTERS);
  const [kraljicThreshold, setKraljicThreshold] = useState(50);

  const setFilters = useCallback((newFilters) => {
    if (typeof newFilters === 'function') {
      setFiltersRaw(prev => ({ ...DEFAULT_FILTERS, ...newFilters(prev) }));
    } else {
      setFiltersRaw({ ...DEFAULT_FILTERS, ...newFilters });
    }
  }, []);

  const resetFilters = useCallback(() => {
    setFiltersRaw(DEFAULT_FILTERS);
    setKraljicThreshold(50);
  }, []);

  return (
    <FilterContext.Provider value={{ filters, setFilters, resetFilters, kraljicThreshold, setKraljicThreshold }}>
      {children}
    </FilterContext.Provider>
  );
}

export function useGlobalFilters() {
  const ctx = useContext(FilterContext);
  if (!ctx) throw new Error('useGlobalFilters must be used inside FilterProvider');
  return ctx;
}
